export const SLIDE_IMAGE_FIT_MODES = ['cover', 'contain', 'stretch'];

export const DEFAULT_SLIDE_IMAGE_FIT_MODE = 'cover';

// Page-background tiles are a fixed fraction of the page width, so a large photo still repeats
// visibly and every renderer (canvas, previews, print) shows the same tiling. Frontend-only: nothing is stored.
export const PAGE_BACKGROUND_TILE_SIZE = '20% auto';

export const resolveSlideImageFitMode = (fitMode) =>
  [...SLIDE_IMAGE_FIT_MODES, 'auto'].includes(fitMode) ? fitMode : DEFAULT_SLIDE_IMAGE_FIT_MODE;

/**
 * CSS background-size for slide/page images.
 * @param {boolean} imageRepeatStatus
 * @param {'cover'|'contain'|'stretch'|'auto'|undefined|null} fitMode
 */
export const getSlideImageBackgroundSize = (imageRepeatStatus, fitMode) => {
  if (imageRepeatStatus === true) return 'auto';
  const mode = resolveSlideImageFitMode(fitMode);
  if (mode === 'stretch') return '100% 100%';
  if (mode === 'auto') return 'auto';
  if (mode === 'cover') return 'cover';
  return 'contain';
};

/**
 * CSS background-size for page backgrounds: like getSlideImageBackgroundSize, but tiles use
 * PAGE_BACKGROUND_TILE_SIZE. Image elements keep natural-size tiles via getSlideImageBackgroundSize.
 * @param {boolean} imageRepeatStatus
 * @param {'cover'|'contain'|'stretch'|'auto'|undefined|null} fitMode
 */
export const getPageBackgroundSize = (imageRepeatStatus, fitMode) =>
  imageRepeatStatus === true ? PAGE_BACKGROUND_TILE_SIZE : getSlideImageBackgroundSize(false, fitMode);
